// extracted by mini-css-extract-plugin
export var button = "_67-4";
export var hasDarkBackground = "_67-7";
export var hasLightBackground = "_67-6";
export var iconWrapper = "_67-0";
export var large = "_67-2";
export var medium = "_67-1";
export var small = "_67-5";
export var xsmall = "_67-3";